// src/pages/Users/SuperDistributors.jsx
import React from 'react';
import UserManagement from './UserManagement';

const SuperDistributors = () => {
  return <UserManagement role="sub-admin" title="Super Distributor" />;
};

export default SuperDistributors;